import FormSelectBox from '../../../../../components/Inputs/FormSelectBox';
import { useGetPreClaimsDocumentTypes } from '../../hooks';

export const PreClaimDocumentTypeSelect = ({
  placeholder = 'Document Type',
  label = 'Document Type',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
}) => {
  const { data: options, isLoading } = useGetPreClaimsDocumentTypes();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      shouldUseNativeSelect
    />
  );
};
